import { render, staticRenderFns } from "./fireProtectionAssistant.vue?vue&type=template&id=cb682398"
import script from "./fireProtectionAssistant.vue?vue&type=script&lang=js"
export * from "./fireProtectionAssistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports